import ReactGA from 'react-ga'

class AnalyticsService {

  // ─── Legacy Methods (kept for backward compatibility) ──────────────────────

  sendEvent = (category, action, label, gtmObject) => {
    ReactGA.event({
      category,
      action,
      label
    })
    window.dataLayer.push(gtmObject)
  }

  sendGa4Event = (gtmObject) => {
    window.dataLayer.push(gtmObject)
  }
  
  sendUniquePageview = (page) => {
    const dataLayer = window.dataLayer

    // Record unique pageviews in an array
    let uniquePageviews = window.sessionStorage.getItem("unique-pageviews");
    if (uniquePageviews) {
      uniquePageviews = JSON.parse(uniquePageviews);
    } else {
      uniquePageviews = [];
    }
  
    // Don't continue if the current page has already been viewed in this session
    if (uniquePageviews.indexOf(page) !== -1) {
      return;
    }
  
    // Track a pageview for a newly visited URL in this session
    uniquePageviews.push(page);
    uniquePageviews = JSON.stringify(uniquePageviews);
    window.sessionStorage.setItem("unique-pageviews", uniquePageviews);
  
    // Send "unique_page_view" event to GA4
    const properties = {
      event: "unique_page_view",
      page_location: page,
    };
    dataLayer.push(properties); 
  }

  // ─── GA4 Standardized Funnel Tracking ──────────────────────────────────────
  //
  // sendGA4FunnelEvent pushes a standardized event to the GTM dataLayer.
  //
  // Security & Privacy:
  //   • No PII (phone numbers, names, emails, addresses) is included.
  //   • Parameters are sanitized — only strings and numbers pass through.
  //   • The method validates that an event name is provided (non-empty string).
  //
  // Usage:
  //   import { PROMO_LANDING_PAGE_VIEW } from "./GA4Events"
  //   AnalyticsService.sendGA4FunnelEvent(PROMO_LANDING_PAGE_VIEW, { page_path: "/" })
  //
  // @param {string} eventName - A constant from GA4Events.js (e.g. "promo_landing_page_view")
  // @param {Object} [params={}] - Optional key-value pairs (no PII allowed)

  sendGA4FunnelEvent = (eventName, params = {}) => {
    // Guard: event name must be a non-empty string
    if (!eventName || typeof eventName !== "string") {
      console.warn("AnalyticsService.sendGA4FunnelEvent: eventName is required and must be a string.")
      return
    }

    // Sanitize parameters — allow only primitive string/number/boolean values
    const sanitizedParams = {}
    const PII_PATTERNS = /phone|email|name|address|ssn|password|token|credential|userinfo/i
    Object.keys(params).forEach((key) => {
      // Block keys that look like PII
      if (PII_PATTERNS.test(key)) {
        return
      }
      const value = params[key]
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        sanitizedParams[key] = value
      }
    })

    const eventPayload = {
      event: eventName,
      event_category: "promotions_funnel",
      ...sanitizedParams,
      timestamp: new Date().toISOString(),
    }

    // Push to GTM dataLayer (GTM forwards to GA4)
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(eventPayload)
    } else {
      console.warn("AnalyticsService.sendGA4FunnelEvent: dataLayer is not available.")
    }
  }
  
}

const analyticsService = new AnalyticsService()

export default analyticsService
